import { RootState } from "@src/store";
import { getProductPickerSelectedProductMap } from "@src/store/slices/productPicker/selectors/getProductPickerSelectedProductMap";

export const isProductPickerProductSelected =
  (productId: string | undefined) => (state: RootState) => {
    const selectedProducts = getProductPickerSelectedProductMap(state);
    return productId ? selectedProducts[productId] !== undefined : false;
  };
